import { render, staticRenderFns } from "./ConfigManage.vue?vue&type=template&id=197b1d7c&scoped=true&"
import script from "./ConfigManage.vue?vue&type=script&lang=js&"
export * from "./ConfigManage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigManage.vue?vue&type=style&index=0&id=197b1d7c&prod&lang=scss&scoped=true&"
import style1 from "./ConfigManage.vue?vue&type=style&index=1&id=197b1d7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b1d7c",
  null
  
)

export default component.exports